import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'
import { PaymentTypeModelType } from '@teinor/erp/types/company/config/paymentType'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderBoolean, CustomRenderIcon, DeleteRow, EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import ModalCEPaymentMethod from './ModalCEPaymentType'
import ModalDeletePaymentMethod from './ModalDeletePaymentType'
import { dictIcon } from '../../../../../utils/icons'
import PaymentTypesSortButton from './PaymentTypesSortButton'
import { useMemo } from 'react'

interface ConfigPaymentTypesProps extends ComponentWithPermissions { }

const ConfigPaymentTypes: React.FC<ConfigPaymentTypesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('paymentTypes', 'Tipos de pago'),
        newText: t('newPaymentMethod2', 'Nuevo tipo de pago'),
    }

    return (
        <BaseScreenTable TableComponent={TablePaymentTypes} CreateModalComponent={ModalCEPaymentMethod} EditModalComponent={ModalCEPaymentMethod} DeleteModalComponent={ModalDeletePaymentMethod} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TablePaymentTypesProps extends TableComponentProps { }

const TablePaymentTypes: React.FC<TablePaymentTypesProps> = ({ setTableInstance, userPermissions, setOpened, tableInstance }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<PaymentTypeModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            width: 200,
            label: t('id', 'ID'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('id', 'ID') }
            }
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('id', 'ID') }
            }
        },
        {
            id: 'code',
            dataKey: 'code',
            label: t('code', 'Código'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('id', 'ID') }
            }
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            generalSearchable: false
        },
        {
            id: 'activeTpv',
            dataKey: 'activeTpv',
            label: t('tpv', 'TPV'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            generalSearchable: false
        },
        {
            id: 'icon',
            dataKey: 'icon',
            label: t('icon', 'Icono'),
            customRender: (parameterValue) => <CustomRenderIcon icon={dictIcon[parameterValue]} />
        },
        {
            id: 'order',
            dataKey: 'order',
            label: t('order', 'Order'),
            sortable: true,
            width: 100
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => {
                const icon = !allRowData?.active ? faRotateLeft : undefined
                return <DeleteRow key={'delete' + parameterValue} {...{ icon, parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />
            },
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    const children = useMemo(() => <PaymentTypesSortButton tableInstance={tableInstance} userPermissions={userPermissions} extraWhereParams={{}} />, [tableInstance, userPermissions])
    return (
        <TwinTable name='paymentTypes' columns={columns} getDataFrom='/api/app/config/payment/paymentType/getAllPaymentTypes' setTableInstance={setTableInstance} onRowClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} >
            {children}
        </TwinTable>
    )
}

export default ConfigPaymentTypes